/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentitySettingsFormData
 */
export interface IdentitySettingsFormData {
    /**
     * 
     * @type {string}
     * @memberof IdentitySettingsFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentitySettingsFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof IdentitySettingsFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof IdentitySettingsFormData
     */
    distributionChannel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof IdentitySettingsFormData
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof IdentitySettingsFormData
     */
    provider?: GuidIdAndLabel;
    /**
     * 
     * @type {object}
     * @memberof IdentitySettingsFormData
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof IdentitySettingsFormData
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentitySettingsFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IdentitySettingsFormData
     */
    timeout?: number;
}

export function IdentitySettingsFormDataFromJSON(json: any): IdentitySettingsFormData {
    return IdentitySettingsFormDataFromJSONTyped(json, false);
}

export function IdentitySettingsFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentitySettingsFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : Int32IdAndLabelFromJSON(json['distributionChannel']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'provider': !exists(json, 'provider') ? undefined : GuidIdAndLabelFromJSON(json['provider']),
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'timeout': !exists(json, 'timeout') ? undefined : json['timeout'],
    };
}

export function IdentitySettingsFormDataToJSON(value?: IdentitySettingsFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowEdit': value.allowEdit,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': Int32IdAndLabelToJSON(value.distributionChannel),
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'provider': GuidIdAndLabelToJSON(value.provider),
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'disabled': value.disabled,
        'timeout': value.timeout,
    };
}


